// extracted by mini-css-extract-plugin
export default {"grid_cont":"GridComp_grid_cont__tcDeK","description_para":"GridComp_description_para__+Kz2d"};